import firebase from "firebase/app";
import "firebase/firestore"
import "firebase/auth"
import "firebase/storage"

const firebaseConfig = {
    apiKey: "AIzaSyBCA4E50G_Gdkce2DtO_GH_KFD0V3brENs",
    authDomain: "music-playlist-26219.firebaseapp.com",
    projectId: "music-playlist-26219",
    storageBucket: "music-playlist-26219.appspot.com",
    messagingSenderId: "724610159698",
    appId: "1:724610159698:web:547f56694b061bcb677b8b"
};

// Firebasega Config orqali ulanish!
firebase.initializeApp(firebaseConfig)

// Firebaseni Servislari
const projectFirestore = firebase.firestore();
const projectAuth = firebase.auth()
const projectStorage = firebase.storage()

// TimeStamp
const timeStamp = firebase.firestore.FieldValue.serverTimestamp;

export {
    projectFirestore,
    projectAuth,
    projectStorage,
    timeStamp
}